// removed by extract-text-webpack-plugin
module.exports = {"icon":"_3vJX","listitem":"_3LT8","text":"_3oh_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ListItem/styles.scss
// module id = 500
// module chunks = 0